import { Box, Divider, Group, Skeleton, Stack } from '@mantine/core'

const SKELETON_BORDER_RADIUS = '40px'

function SingleTableCellSkeleton({ flex }: { flex?: number }) {
  return <Skeleton h="20px" bdrs={SKELETON_BORDER_RADIUS} flex={flex} />
}

const SKELETON_ROW_COUNT = 20
const COLUMN_COUNT = 6

function TableRowSkeleton({ isTableHeader }: { isTableHeader?: boolean }) {
  return (
    <>
      <Group justify="space-between" wrap="nowrap">
        {Array.from({ length: COLUMN_COUNT }).map((_, index) => (
          <SingleTableCellSkeleton key={index} flex={1} />
        ))}
      </Group>
      {isTableHeader && (
        <Divider my="12px" style={{ '--divider-color': 'var(--border-surface-default)' }} />
      )}
    </>
  )
}

export default function StockTableSkeleton() {
  return (
    <Box>
      <TableRowSkeleton isTableHeader />
      <Stack gap="32px" mt="12px">
        {Array.from({ length: SKELETON_ROW_COUNT }).map((_, index) => (
          <TableRowSkeleton key={index} />
        ))}
      </Stack>
    </Box>
  )
}
